import { useAtom } from '@reatom/npm-react'
import { memo, useCallback } from 'react'

import { tradingDrawerAtom } from '../../atoms'

import { OrdersDrawer } from './orders-drawer/orders-drawer'
import { PositionsDrawer } from './positions-drawer/positions-drawer'
import { RecentPairsDrawer } from './recent-pairs-drawer/recent-pairs-drawer'

type TradingScreenProps = {}

export const TradingDrawers: React.FC<TradingScreenProps> = memo(() => {
  const [activeDrawer, setActiveDrawer] = useAtom(tradingDrawerAtom)

  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) {
        setActiveDrawer(undefined)
      }
    },
    [setActiveDrawer],
  )

  return (
    <>
      <RecentPairsDrawer
        open={activeDrawer === 'recent-pairs'}
        onOpenChange={handleOpenChange}
      />
      <PositionsDrawer
        open={activeDrawer === 'positions'}
        onOpenChange={handleOpenChange}
      />
      <OrdersDrawer
        open={activeDrawer === 'orders'}
        onOpenChange={handleOpenChange}
      />
    </>
  )
})
TradingDrawers.displayName = 'TradingDrawers'
